export default (
  state = {
    selected_products: [],
    missing_items: null,
  },
  action,
) => {
  switch (action.type) {
    case 'SELECTED_PACKAGE_ITEM':
      return {
        ...state,
        selected_item_index: action.index,
      };
    case 'ADD_PACKAGE_ITEM_SIZE': {
      const updatedSelectedProducts = [
        ...state.selected_products.filter(
          el => el.product_id !== action.sizeDetails.product_id,
        ),
        action.sizeDetails,
      ];
      const newState = {
        ...state,
        selected_products: updatedSelectedProducts,
      };
      return newState;
    }
    case 'SET_MISSING_ITEMS': {
      const newState2 = {
        ...state,
        missing_items: action.missingItems,
      };
      return newState2;
    }
    case 'ADD_PACKAGE_TO_CART':
      return {
        ...state,
        success: true,
      };
    default:
      return state;
  }
};
